/* eslint-disable react/forbid-dom-props */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from './spzaComponent';
import { routes } from '@shared/routerHistory';
import { Link } from 'react-router-dom';
import { ExternalLink } from './externalLink';
export class SuccessStory extends SpzaComponent {
    getAppTile(app, tileKey) {
        const { iconURL, shortDescription, shortDescriptionFallback, entityId, productFamily, title } = app;
        const route = this.context.buildHref(routes.appDetails, {
            productId: productFamily,
            entityId
        }, {
            tab: 'Overview'
        });
        const description = this.context.loc(shortDescription, shortDescriptionFallback);
        return /*#__PURE__*/ _jsxs("div", {
            className: "tileWrapper",
            children: [
                /*#__PURE__*/ _jsx("img", {
                    className: "icon",
                    src: iconURL,
                    alt: description
                }),
                /*#__PURE__*/ _jsx("h2", {
                    className: "title",
                    children: title
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "description",
                    children: description
                }),
                /*#__PURE__*/ _jsx(Link, {
                    className: "link",
                    "data-bi-id": entityId,
                    "data-bi-area": "SuccessStory learn more link",
                    to: route,
                    children: this.context.loc('AppSource_Banner_LearnMore', 'Learn more >')
                })
            ]
        }, tileKey);
    }
    renderMarketplaceRecommendation(app, tileKey) {
        const { iconURL, url } = app;
        return /*#__PURE__*/ _jsxs("div", {
            className: "tileWrapper",
            children: [
                /*#__PURE__*/ _jsx("img", {
                    src: iconURL,
                    alt: "logo"
                }),
                /*#__PURE__*/ _jsx(ExternalLink, {
                    href: url,
                    className: "link",
                    accessibilityEnabled: true,
                    target: "_blank",
                    rel: "noreferrer",
                    children: this.context.loc('Marketplace_Banner_ReadTheirStory', 'Read their story >')
                })
            ]
        }, tileKey);
    }
    renderImpl() {
        const { author: { name, title }, description, descriptionFallback, recommendations, image, isConverged } = this.props;
        const backgroundImage = {
            backgroundImage: `linear-gradient(256.63deg, rgba(0, 0, 0, 0) 45%, rgba(0, 0, 0, 0.55)), url(${image})`
        };
        return /*#__PURE__*/ _jsxs("div", {
            className: "storyContainer",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "image",
                    style: backgroundImage,
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "contentContainer",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "testimonial",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "title",
                                        children: this.context.loc(description, descriptionFallback)
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "author",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "authorName",
                                                children: name
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "authorTitle",
                                                children: title
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "apps appsDesktop",
                                children: recommendations.map((app, index)=>isConverged ? this.renderMarketplaceRecommendation(app, index) : this.getAppTile(app, index))
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "apps appsMobile",
                    children: recommendations.map((app, index)=>isConverged ? this.renderMarketplaceRecommendation(app, index) : this.getAppTile(app, index))
                })
            ]
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "context", void 0);
    }
}
SuccessStory.contextTypes = {
    buildHref: PropTypes.func,
    renderErrorModal: PropTypes.func,
    loc: PropTypes.func
};
